export const Color = {
  black0: 'rgb(0, 0, 0)',
  black1: 'rgb(8, 8, 8)',
  black2: 'rgb(16, 16, 16)',
  black3: 'rgb(24, 24, 24)',
  black4: 'rgb(32, 32, 32)',
  black5: 'rgb(40, 40, 40)',
  black6: 'rgb(48, 48, 48)',
  black7: 'rgb(56, 56, 56)',
  black8: 'rgb(64, 64, 64)',
  black9: 'rgb(72, 72, 72)',

  white0: 'rgb(255, 255, 255)',
  white1: 'rgb(235, 235, 235)',
  white2: 'rgb(215, 215, 215)',
  white3: 'rgb(195, 195, 195)',
  white4: 'rgb(175, 175, 175)',
  white5: 'rgb(155, 155, 155)',
  white6: 'rgb(135, 135, 135)',
  white7: 'rgb(115, 115, 115)',
  white8: 'rgb(95, 95, 95)',
  white9: 'rgb(75, 75, 75)',

  alpha: {
    black0: 'rgba(0, 0, 0, 0.0)',
    black1: 'rgba(0, 0, 0, 0.05)',
    black2: 'rgba(0, 0, 0, 0.1)',
    black3: 'rgba(0, 0, 0, 0.15)',
    black4: 'rgba(0, 0, 0, 0.2)',
    black5: 'rgba(0, 0, 0, 0.25)',
    black6: 'rgba(0, 0, 0, 0.3)',
    black7: 'rgba(0, 0, 0, 0.35)',
    black8: 'rgba(0, 0, 0, 0.4)',
    black9: 'rgba(0, 0, 0, 0.45)',

    white0: 'rgba(255, 255, 255, 0.0)',
    white1: 'rgba(255, 255, 255, 0.05)',
    white2: 'rgba(255, 255, 255, 0.1)',
    white3: 'rgba(255, 255, 255, 0.15)',
    white4: 'rgba(255, 255, 255, 0.2)',
    white5: 'rgba(255, 255, 255, 0.25)',
    white6: 'rgba(255, 255, 255, 0.3)',
    white7: 'rgba(255, 255, 255, 0.35)',
    white8: 'rgba(255, 255, 255, 0.4)',
    white9: 'rgba(255, 255, 255, 0.45)',
  },
};
